import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Text } from '@chakra-ui/react';
import { isObject } from '@progress-fe/core';
import Latex from 'react-latex-next';
const TableValueFC = ({ value, isDisabled, isFormula, render }) => {
    const renderedValue = isObject(value) ? value?.value : value;
    const unit = isObject(value) ? value?.unit : undefined;
    return render ? (render(renderedValue || '')) : (_jsx(Text, { fontSize: "12px", color: "bodyText", opacity: isDisabled ? '0.5' : '1', textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", width: "100%", children: isFormula && renderedValue ? (_jsx(Latex, { children: renderedValue })) : (_jsxs(_Fragment, { children: [renderedValue, " ", unit && _jsxs(_Fragment, { children: ["(", unit, ")"] })] })) }));
};
export const TableValue = memo(TableValueFC);
//# sourceMappingURL=TableValue.js.map